import React from "react";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";

interface MobileSideBar{
    drawerWidth:number,
    handleDrawerToggle:()=>void
}

export const MobileSideBar = ({drawerWidth, handleDrawerToggle}:MobileSideBar) =>{
    return(
                    <AppBar
                        position="fixed"
                sx={{
                    display:{md:"none",lg:"none",sm:"none",xs:"block"},
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                }}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2, display: { sm: 'none' } }}
            >
                <MenuIcon />
                </IconButton>
                </Toolbar>
                </AppBar>
    )
}